/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Embed_Export_Progress_RunningInputs */



/**
* | output |
* | --- |
* | "Embedding audio... {timecode}" |
*
* @param {Audio_Embed_Export_Progress_RunningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_running = /** @type {((inputs: Audio_Embed_Export_Progress_RunningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_RunningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Intégration audio... ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audio wird eingebettet... ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Incorporamento audio... ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Встраивание аудио... ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Insertando audio... ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`嵌入音频... ${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`音声を埋め込んでいます... ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो एम्बेड किया जा रहा है... ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Incorporando áudio... ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Embedding audio... ${i?.timecode}`)
});